var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffice365Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_5772_127)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5772_127",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5772_127",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5772_127",
    width: 24,
    height: 24,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAAA40lEQVRIDWP8/PnzfwYaAhaw2bnODAy/fhC2xj+N4bTBJ4YTT7sIqmVh4mLINL7JALEAZPjP7wQ1Mfz7y/Cf4Q/D73/fCKtlZASrYSKskjIVoxYQDL/RIBr4IIJkNGAOBWUigkDdiEGa9yeDjWwNQaWM0DwMtmCyWiwwf0JyHj6dVkIMDJb/TzEo/ies9j8wJ/8GGga2oPPWf4ZvfwmXebWaTAy2nMcZ2B614nMHRI6Zm+G3VA7DaDIlGFSjQTQCggic0biYGRigVSheL7MAa+T/jEAtwExECPxn4gQrYaR1swUAjPI1aeygLcAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice365Icon);
export default __webpack_public_path__ + "static/media/office365Icon.7f7b0e3516845afcf83e420f559c698f.svg";
export { ForwardRef as ReactComponent };